import moment from 'moment';

export default function (date, format = 'MM/DD/YYYY') {
  return (moment.isMoment(date))
    ? date.format(format)
    : moment(date).format(format);
}



/** WEBPACK FOOTER **
 ** ./src/utils/dateFormat.js
 **/